export const FOLDER_HEADER_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderHeaderUpdated";
export const FOLDER_HEADER_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.FolderHeaderInvalidated";
export const FOLDER_ACTIVE_STEP_CHANGED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderActiveStepChanged";
export const FOLDER_WARNINGS_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderWarningsChanged";
export const DOCUMENT_WORKFLOW_ERROR_DISMISSED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentWorkflowErrorDismissed";
